export enum ContentType {
    List = 'list',
    Page = 'page',
    Rss = 'rss',
    Contact = 'contact',
    Web = 'web',
    Image = 'image',
    File = 'file',
    Video = 'video',
    NotAccepted = 'notAccepted',
    Audio = 'audio',
    Form = 'form'
}

export enum MediaKind {
    Unknown = 'Unknown',
    Image = 'image',
    File = 'file',
    Audio = 'audio',
    Video = 'video',
    Web = 'web'

}

export enum SearchRules {
    None = 0,
    SearchTitlesOnly = 1
}

export enum MatchType {
    Media = 'media',
    Title= 'title',
    Multiple = 'multiple',
    Text = 'text'

}

export enum FoundInType {
    Single='single',
    Multiple='multiple'
}

export enum ContentStatus {
    Published = 'published',
    Draft = 'draft'
}

export enum ContextLocation
{
    Unknown = 'unknown',
    Start = 'start',
    Middle = 'middle',
    End = 'end',
    Full = 'full'
}

export interface Search {
    nextSkip: number,
    previousSkip: number,
    totalItemCount: number,
    items: SearchResult[]
}



export interface SearchResult {
    contentType: ContentType,
    contentUrl: string,
    title: string,
    publishDate: string,
    modifiedDate: string,
    ietfLanguageTag: string,
    featuredImage: {
      height: number,
      width: number,
      aspectRatio: string,
      url: string
      fileName: string,
      mediaType: string,
      size: number
    },
    match: Match,
    foundIn: FoundIn,
    contentStatus: ContentStatus
}

export interface Match {
    matchType: MatchType,
    caption: string,
    filename: string,
    mediaKind: MediaKind,
    count: number,
    context: string,
    contextLocation: ContextLocation,
    contentType: ContentType

}

export interface FoundIn {
    foundInType: FoundInType
    locationPath: string[]
    count: number
    parentIdsAndTitles: ParentTitleAndId[]
}

export  interface ParentTitleAndId {
    id:number;
    title:string
}

export interface SearchFilters {
    searchTerm: string,
    typeFilter: string[],
    dateFilter: string,
    languageFilter: string[],
    rulesFilter: string[]
}

export interface ContentSearchRequest
    {
        contentStatuses?: string[],
        languageFilters?: string[],
        mediaKindFilters?: MediaKind[],
        rules?: string[],
        searchTerm: string,
        since?: string
    }




